import React, { Component, HTMLProps } from 'react';

class CustomTextArea extends Component<Props> {
  public render() {
    const { className, ...rest } = this.props;

    return (
      <textarea
        className={
          'w-full pt-2 rounded-[4px] disabled:opacity-50 focus:outline-none text-sm  focus:formica-shadow  outline-none! indent-3 text-f-black-2 border-[1px] border-f-black-5 bg-white focus:border-f-purple hover:border-f-purple disabled:cursor-not-allowed ' +
          className
        }
        {...rest}
      />
    );
  }
}

interface Props extends HTMLProps<HTMLTextAreaElement> {}

export default CustomTextArea;
